<template>
  <div class="service-list">
    <div class="list-service-appointment">
      <img v-if="iconUrl" :src="iconUrl" class="icon" />
      <div :class="metaClassList" class="meta">
        <router-link v-if="route" :to="route" class="name">{{
          name
        }}</router-link>
        <h4 v-else class="name">{{ name }}</h4>
        <p class="desc">{{ desc }}</p>
        <p v-if="mainOptionTitle">Option หลัก: {{ mainOptionTitle }}</p>
        <p v-if="extraOptionTitles">Option เสริม: {{ extraOptionTitles }}</p>
        <div class="provider">
          <img v-if="provider.logoUrl" :src="provider.logoUrl" class="logo" />
          <p class="name">{{ provider.name }}</p>
        </div>
        <div v-if="qualityUnitText" class="name">{{ qualityUnitText }}</div>
      </div>
    </div>
    <div v-if="appointmentDate" class="appointment">
      <div class="count">{{ appointmentQuota }}</div>
      <div class="date">{{ appointmentDate }}</div>
      <div class="clear-both"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconUrl: { type: String, default: "" },
    name: { type: String, default: "" },
    shortDescription: { type: String, default: "" },
    description: { type: String, default: "" },
    provider: { type: Object, default: () => ({}) },
    route: { type: [String, Object], default: null },
    appointmentCount: { type: [Number, String], default: null },
    currentAppointmentDate: { type: String, default: "" },
    totalAppointment: { type: [Number, String], default: null },
    mainOptionTitle: { type: String, default: "" },
    extraOptionTitles: { type: String, default: "" },
    qualityUnit: { type: String, default: "" },
  },
  computed: {
    desc() {
      return (
        [this.shortDescription, this.description].filter(Boolean).join(" — ") ||
        "-"
      )
    },
    metaClassList() {
      return { "no-icon": !this.iconUrl }
    },
    appointmentQuota() {
      return this.totalAppointment
        ? `จำนวนครั้ง ${this.appointmentCount}/${this.totalAppointment}`
        : "สินค้า"
    },
    appointmentDate() {
      return this.currentAppointmentDate
        ? `นัดหมายล่าสุด: ${this.currentAppointmentDate}`
        : ""
    },
    qualityUnitText() {
      return !this.totalAppointment ? this.qualityUnit : undefined
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 64px;

.service-list {
  border-bottom: $border;
}

.list-service-appointment {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;

  padding: ($space / 2) 0;

  > .icon {
    margin-top: 5px;
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: $logoSize;
    flex: 0 0 $logoSize;
  }

  > .icon + .meta {
    padding-left: $space;
  }

  > .meta {
    display: block;

    flex-grow: 1;
  }
}

.meta {
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .provider {
    margin-top: 5px;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 12px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.appointment {
  font-size: 1rem;

  > .count {
    float: left;
  }

  > .date {
    float: right;
  }

  > .clear-both {
    clear: both;
  }
}
</style>
